export const BOX_CHARACTER_THRESHOLD = 300;
export const BOX_HEIGHT_THRESHOLD = "14rem";
